import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const ArrowLeftIcon: React.FunctionComponent<IconProps> = ({
  width = 8,
  height = 12,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={8} viewBoxHeight={12} {...rest}>
    <path d="M7.49833 1.49029L3.17278 6.04549L7.49833 10.6007L6.16667 12L0.5 6.04549L6.16667 0.0909786L7.49833 1.49029Z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon/arrow-left.icon.tsx